package com.ustadmobile.core.components

import react.FC
import react.Props

/**
 * Empty placeholder component that is simply used as a dummy entry we can navigate to for purposes
 * of clearing history stack.
 * @see NavHost
 */
val NavHostClearStackPlaceholder = FC <Props> { props ->
    //Nothing here
}